import { Overlay, PopupContainer } from "../popups/Popup";
import styled from "@emotion/styled";
import { COLOR_TERTIARY, FLEX_COLUMN, FLEX_ROW, IconSize } from "../theme";
import {
  ParagraphHeaderXLarge,
  ParagraphSmall,
  SemiboldSmall,
} from "../typography/Paragraph";
import DocumentCart from "../icons/DocumentCart";
import GreenTick from "../icons/GreenTick";
import IconContainer from "../icons/IconContainer";
import { PrimaryButton } from "../buttons/PrimaryButton";
import { StyledLinkButton } from "../AttorneyServicesUnpaid";
const StyledPopupContainer = styled(PopupContainer)`
  max-width: 560px;
  width: 100%;
  padding: 24px 48px;
`;

const TitleContainer = styled.div`
  ${FLEX_ROW}
  gap: 8px;
  align-items: center;
  justify-content: center;
`;

const InstructionsTextContainer = styled.div`
  ${FLEX_COLUMN}
  gap: 8px;
`;

const InstructionItem = styled.div`
  ${FLEX_ROW}
  gap: 8px;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  padding: 0 24px;
`;

const instructionsText = (stateName: string) => {
  return [
    <>
      <SemiboldSmall>Discounted legal services</SemiboldSmall> with HelloPrenup
      partnered {stateName} attorneys.
    </>,
    "State-specific, customized prenuptial agreement",
    "24/7 platform access, dedicated support team",
  ];
};

export interface CompletePaymentModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  componentRef: React.RefObject<HTMLDivElement>;
  stateName: string;
}
const CompletePaymentModal = ({
  onConfirm,
  onCancel,
  componentRef,
  stateName,
}: CompletePaymentModalProps) => {
  return (
    <Overlay>
      <StyledPopupContainer ref={componentRef} backgroundColor={COLOR_TERTIARY}>
        <TitleContainer>
          <DocumentCart />
          <ParagraphHeaderXLarge fontWeight={500}>
            Complete payment to continue
          </ParagraphHeaderXLarge>
        </TitleContainer>
        <InstructionsTextContainer>
          {instructionsText(stateName).map((text, index) => (
            <InstructionItem key={index}>
              <IconContainer
                backgroundColor="none"
                width={IconSize.S}
                height={IconSize.S}
              >
                <GreenTick />
              </IconContainer>
              <ParagraphSmall>{text}</ParagraphSmall>
            </InstructionItem>
          ))}
        </InstructionsTextContainer>
        <PrimaryButton onClick={onConfirm}>Checkout</PrimaryButton>
        <StyledLinkButton onClick={onCancel}>Go back</StyledLinkButton>
      </StyledPopupContainer>
    </Overlay>
  );
};

export default CompletePaymentModal;
